// Riding'times July Promotion Countdown
(function () {
  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function getTargetTime(el) {
    var targetText = el.getAttribute('data-countdown-target');
    if (!targetText) return null;

    var target = new Date(targetText).getTime();
    return isNaN(target) ? null : target;
  }

  function updateOne(root) {
    var target = getTargetTime(root);
    if (!target) return;

    var distance = Math.max(0, target - new Date().getTime());

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
    var minutes = Math.floor((distance / (1000 * 60)) % 60);
    var seconds = Math.floor((distance / 1000) % 60);

    root.querySelectorAll('[data-days]').forEach(function (el) {
      el.textContent = pad(days);
    });

    root.querySelectorAll('[data-hours]').forEach(function (el) {
      el.textContent = pad(hours);
    });

    root.querySelectorAll('[data-minutes]').forEach(function (el) {
      el.textContent = pad(minutes);
    });

    root.querySelectorAll('[data-seconds]').forEach(function (el) {
      el.textContent = pad(seconds);
    });
  }

  function init() {
    var countdowns = document.querySelectorAll('[data-rt-countdown-root]');
    if (!countdowns.length) return;

    countdowns.forEach(function (root) {
      updateOne(root);
      setInterval(function () {
        updateOne(root);
      }, 1000);
    });

    document.querySelectorAll('[data-rt-sticky-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var root = btn.closest('.rt-july-sticky');
        if (root) {
          root.style.display = 'none';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();